/* unplugin-vue-components disabled */import { render } from "./follow-btn.vue?vue&type=template&id=9d1d3b64&scoped=true"
import script from "./follow-btn.vue?vue&type=script&lang=js"
export * from "./follow-btn.vue?vue&type=script&lang=js"

import "./follow-btn.vue?vue&type=style&index=0&id=9d1d3b64&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d1d3b64"],['__file',"src/components/cards/company/follow-btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d1d3b64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d1d3b64', __exports__)) {
    api.reload('9d1d3b64', __exports__)
  }
  
  module.hot.accept("./follow-btn.vue?vue&type=template&id=9d1d3b64&scoped=true", () => {
    api.rerender('9d1d3b64', render)
  })

}


export default __exports__